import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function DeleteCMFileAssetService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/deleteCMFileAsset`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        {
        notify.NotifySuccess('File deleted successfully.')
        }
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while  deleting file. please try again later.");
        return false;
    });
}
export default DeleteCMFileAssetService;